import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CheckIcon from '../../../../../assets/icons/check.svg';
import CloseIcon from '../../../../../assets/icons/close.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {certificate} = contexts;

  const data: EventData = {};

  data.avatar = getYcLogoFile(180);
  data.avatarPlaceholder = 'Your Coach';

  data.title =
    /**
     * @i18n_parser
     *
     * t('notifications:certificate_approved.title')
     * t('notifications:certificate_rejected.title')
     */
    i18n.t(`notifications:${event.type}.title`, {
      certificateSchool: certificate?.school,
      certificateTitle: certificate?.title,
    });

  if (event.type === 'certificate_approved') {
    data.icon = CheckIcon;
    data.iconGradient = 'success';
  } else {
    data.icon = CloseIcon;
    data.iconGradient = 'danger';
  }

  return data;
};
